import { render } from "./InformazioniDet.vue?vue&type=template&id=294b584b"
import script from "./InformazioniDet.vue?vue&type=script&lang=js"
export * from "./InformazioniDet.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__